import Petition from "../../../modules/petition";

// /**
//  * Use Petition
//  *
//  * You must use pet.get(url) or pet.post(url, data)
//  */
const pet = new Petition()

export class apiService {
  welcome() {
    return 'welcome to ApiService';
  }
  async sendDataTrivia(data: object) {
    return await pet.post("/s4v3_2serie1", data)
  }

  async triviaStatus(triviaId: number) {
    return await pet.get(`/trivia_status?trivia=${triviaId}`)
  }

  async getUSerTapit() {
    return await pet.get(`/read/data/user`)
  }

  async getUserPoints() {
    return await pet.get('/user/points')
  }

  async getQuestionsPrizes() {
    return await pet.get('/user/questions')
  }

  async getRankingData() {
    return await pet.get('/user/trivia/ranking')
  }

  async sendQuestionAnswer({questionId, optionId}: any) {
    var formData = new FormData();
    formData.append("q_id", questionId);
    formData.append("answer", optionId);
    return await pet.postFD('/user/question', formData)
  }
}
